<template>
	<div class="board">
		<van-notice-bar left-icon="volume-o" :scrollable="false">
			<van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
				<van-swipe-item> 订单总数：{{informationList.order_num}}</van-swipe-item>
				<van-swipe-item> 待发货订单：{{informationList.sate_pay_num}}</van-swipe-item>
				<van-swipe-item> 待售后订单：{{informationList.refund_return_num}}</van-swipe-item>
				<van-swipe-item> 今日订单数量：{{informationList.order_today_num}}</van-swipe-item>
				<van-swipe-item> 日订单总金额：{{informationList.order_today_sum}}</van-swipe-item>
				<van-swipe-item> 供应商品总数：{{informationList.goods_common_num}}</van-swipe-item>
			</van-swipe>
		</van-notice-bar>
		<div class="new-notice">
			<div class="notice-title">上新公告</div>
			<van-notice-bar scrollable v-for="(item, itemKey) in newList" :key="itemKey" :delay="itemKey*1.5"
				@click="toDetail(item)">
				{{item.amt_title}} —— {{item.amt_time}}</van-notice-bar>
		</div>
	</div>
</template>

<script>
	import { getSellerIndex } from '../../../api/sale'
	export default {
		name: 'SaleBoard',
		components: {
		},
		props: [],
		data() {
			return {
				// 系统概括列表
				SellerList: [],
				// 上新列表
				newList: [],
				// 通知信息
				informationList: {}
			}
		},
		methods: {
			toDetail({ amt_url }) {
				if (amt_url) {
					location.href = amt_url
				} else {
					return false
				}
			}
		},
		created() {
			getSellerIndex().then(res => {
				// 通知信息
				this.informationList = res.result
				// 上新列表
				this.newList = res.result.announcement_list
			}).catch(error => {
				// this.$router.push('Home')
			})
		}
	}
</script>

<style lang="scss" scoped>
	.notice-swipe {
		height: 40px;
		line-height: 40px;
	}

	.board {
		font-size: 12px;
		color: #606266;

		.home-title {
			display: flex;
			align-items: center;
			padding: 10px;
			font-size: 14px;
			color: white;
			background-color: #e93b3d;

			.first {
				margin-right: 10px;
			}
		}

		.new-notice {
			background-color: #fff;
			box-shadow: 0 0 5px #EEEEEE;
			margin: 10px;
			border-radius: 10px;
			padding: 10px;

			.notice-title {
				font-weight: bold;
				padding-bottom: 10px;
			}

			.notice-font-wapper {
				.notice-font-item {
					display: flex;
					justify-content: space-between;

					.info-label {
						color: #1989FA;
					}
				}

				.notice-font-item:not(:last-child) {
					margin-bottom: 10px;
				}
			}
		}
	}

	.board   ::v-deep.van-tabs {
		margin-top: 15px;

		.van-tab__pane {
			margin: 10px 0;
			padding: 0 15px;
		}
	}
</style>